import createNamedWrapperReducer from "@frameworks/web/redux/feature/Markets/Equity/wrapperReducer";
import { combineReducers } from "redux";
import FamilyDetails from "./FamilyDetails";
import ConsolidatedDetails from "./ConsolidatedDetails";
import { ERevampReportReducers } from "@adapters/presenters/action-interfaces/Reports/DashboardSummary";
export default combineReducers({
    familyDetails: createNamedWrapperReducer(FamilyDetails, ERevampReportReducers.FamilyTagging),
    consolidatedDetails: createNamedWrapperReducer(ConsolidatedDetails, "consolidatedDetails"),
});
